module.exports = __webpack_public_path__ + "static/media/nectarine.8d497e4c.png";